import UserPreferencesMenuItems from '@popup/steem/pages/app-container/settings/user-preferences/user-preferences-menu-items';
import { useThemeContext } from '@popup/theme.context';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { MenuComponent } from 'src/common-ui/menu/menu.component';
const UserPreferencesPage = ({}) => {
    const { toggleTheme } = useThemeContext();
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_USER_PREFERENCES}-page`, className: "user-preferences-page" },
        React.createElement(MenuComponent, { title: "popup_html_user_preferences", isBackButtonEnable: true, menuItems: UserPreferencesMenuItems(toggleTheme) })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const UserPreferencesPageComponent = connector(UserPreferencesPage);
